import React, { Component, Fragment } from 'react';

import { userSessionIcon } from './svgIcons';
import CommonUtil from '../../../utils/commonUtil';
import serverClientUtil from '../../../utils/serverClientUtil';

const channel = CommonUtil.getChannel();
const isWeb = (channel === 'web');

class UserHeadingSession extends Component {
  constructor(props) {
    super(props);
    this.state = {
      widthBtnUserSession: {},
    };
  }

  componentDidMount() {
    this.getBounding();
  }

  getBounding = () => this.setState({
    widthBtnUserSession: document.getElementById('customerNameBtnWrap').getBoundingClientRect(),
  })


  render() {
    const userAccount = `${serverClientUtil.getLPURL()}/tienda/users/myAccount`;
    const { name, lastNameFather, hasActiveSession } = this.props.customer || {};
    const { handleLogin = () => {}, classname = '' } = this.props || {};
    const { widthBtnUserSession } = this.state;

    const tab = '\u00A0';
    const isWapActiveSession = (!isWeb && hasActiveSession);
    const widthElem = widthBtnUserSession.width;

    return (
      <Fragment>
        <div
          className={`innerMenuSectionTitle ${classname || ''}`} id="customerNameBtnWrap"
          style={{
            width: hasActiveSession ? '100%' : '200px',
            padding: (hasActiveSession || isWeb) ? '12px 12px 12px 18px' : '0',
          }}
        >
          <div>{userSessionIcon('wap', `${hasActiveSession ? 'aditionalClassForUserIcon' : ''}`)}</div>
          <div className="initSessionContainer textIndentEfect" style={{ width: '100%' }}>
            <button
              className={`${!hasActiveSession ? '' : 'font18'} resetDefaultStyleBtn forEllipsisText`}
              style={{ maxWidth: (isWapActiveSession && widthElem) ? widthElem - 125 : '125px' }}
              onClick={()=> {CommonUtil.handleRedirect()}}
            >
              {
                hasActiveSession
                  ? <span>{`${name}${tab}${lastNameFather}`}</span>
                  : <span>Iniciar sesión</span>
              }
            </button>
            {
              hasActiveSession ? (
                <div style={{ lineHeight: 0, marginTop: (isWeb && hasActiveSession) ? '0px' : '-10px' }}>
                  <button
                    className={'resetDefaultStyleBtn'}
                    onClick={hasActiveSession ? () => { window.location.href = userAccount; } : () => {}}
                  >
                    Mi cuenta
                  </button>
                  <span className="chevron chevronLeft left" style={{ marginTop: 0, marginLeft: 0 }} />
                </div>
              )
              : ''
            }
          </div>
        </div>
        { isWeb && (<hr className="style" />) }
      </Fragment>
    );
  }
}

export default UserHeadingSession;
